import React, { useState, useContext } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../context/UserContext";

const API_BASE = "https://tn.server.goatteachers.com/api";

const AdminLogin = () => {
  const { user, loginUser } = useContext(UserContext);

  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!email || !password) {
      setError("Email and password required");
      return;
    }

    try {
      setLoading(true);

      const res = await axios.post(`${API_BASE}/admin/login`, {
        email: email.trim(),
        password,
      });

      const token = res.data?.token;
      if (!token) throw new Error("Invalid login response");

      // 🔐 Save admin as user
      loginUser({
        token: res.data.token,
        role: res.data?.admin?.role || "admin",
        email: res.data?.admin?.email || email,
      });

      navigate("/tn-admin");
    } catch (err) {
      console.error("Admin login error:", err);
      setError(
        err?.response?.data?.message || "Login failed. Check credentials.",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 16,
        background: "#f7f7f7",
      }}
    >
      <form
        onSubmit={handleSubmit}
        style={{
          width: "100%",
          maxWidth: 420,
          background: "#fff",
          borderRadius: 16,
          padding: 24,
          boxShadow: "0 20px 50px rgba(0,0,0,0.15)",
        }}
      >
        <h2 style={{ marginBottom: 6, fontWeight: 900 }}>Admin Login</h2>
        <p style={{ fontSize: 13, opacity: 0.75, marginBottom: 16 }}>
          Restricted access — admins only
        </p>

        <div style={{ marginBottom: 12 }}>
          <label style={{ fontWeight: 800, fontSize: 13 }}>Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="admin@goatt.com"
            autoComplete="username"
            style={{
              width: "100%",
              padding: 12,
              borderRadius: 12,
              border: "1px solid #e7e7e7",
              marginTop: 6,
              color: "#000000",
            }}
          />
        </div>

        <div style={{ marginBottom: 12 }}>
          <label style={{ fontWeight: 800, fontSize: 13 }}>Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            style={{
              width: "100%",
              padding: 12,
              borderRadius: 12,
              border: "1px solid #e7e7e7",
              marginTop: 6,
              color: "#000000",
            }}
          />
        </div>

        {error && (
          <div
            style={{
              color: "crimson",
              fontSize: 13,
              marginBottom: 12,
            }}
          >
            {error}
          </div>
        )}

        <button
          type="submit"
          disabled={loading}
          style={{
            width: "100%",
            padding: 14,
            borderRadius: 14,
            border: "none",
            background: loading ? "#999" : "#111",
            color: "#fff",
            fontWeight: 900,
            cursor: loading ? "not-allowed" : "pointer",
          }}
        >
          {loading ? "Logging in…" : "Login"}
        </button>
      </form>
    </div>
  );
};

export default AdminLogin;
